<section scId="SC1106">
  <ng-container *ngIf="contentData && customerAccountBillingDetails && nickName !== ''">
    <tmo-page-titles
      id="page-title"
      [pageTitle]="contentData?.hi + ' ' + nickName"
      [grayBackground]="true"
      [accountPage]="true"
      [accountText]="contentData?.account"
      [nickName]="nickName"
      [accountId]="customerAccountBillingDetails?.accountNumber"
      [numAlerts]="totalNotifications"
      [alertSuffix]="contentData?.notifications"
      (toggleAlertEmitter)="toggleAlertChange($event)"
    >
    </tmo-page-titles>
    <div class="row" *ngIf="isFraudLock">
      <div class="col-xs-12 m-t-lg m-b-lg">
        <p class="alert-text"><i class="fa fa-flag def alert-icon"></i>{{ fraudLockIndicator }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 m-t-lg m-b-lg" *ngIf="isTouristPlan">
        <p class="alert-text">
          <i class="fa fa-flag def alert-icon"></i>{{ contentData?.touristPlanChangeMessage }}
        </p>
      </div>
    </div>
    <div hidden="true" id="existingTotalNumberOfLines">
      {{ accountLineDetailsModel?.customerAccountLineDetails?.length }}
    </div>
    <tmo-alerts-section
      id="alert"
      (totalAccountNotifications)="updateNotifications($event)"
      [contentData]="contentData"
      [toggleAlerts]="!toggleAlerts"
      [showIndicators]="true"
      (navigateToSessionPass)="checkAutoNavigate($event)"
    ></tmo-alerts-section>
    <tmo-billing-block
      id="bill-block"
      [showAddALine]="showAddALine"
      [clearAutoPay]="true"
      (openAccordion)="showAccordion($event)"
      [customerAccountBillingDetails]="customerAccountBillingDetails"
      [isTouristPlan]="isTouristPlan"
      [isP10MCustomer]="isP10MCustomer"
    ></tmo-billing-block>
    <ng-container *ngIf="customerAccountBillingDetails">
      <tmo-account-line-details
        id="line-details"
        *ngIf="primaryMsisdn && accountLineDetailsModel"
        [accountLineDetailsModel]="accountLineDetailsModel"
        [contentData]="contentData"
        [isTouristPlan]="isTouristPlan"
        [isP10MCustomer]="isP10MCustomer"
        [primaryMsisdn]="msisdnInput"
        [permissionEnabled]="permissionEnabled"
      ></tmo-account-line-details>
    </ng-container>
    <ng-template #showSpinner>
      <div class="row">
        <div class="col-12 text-center">
          <i class="fa fa-spinner fa-pulse spinner-icon"></i>
        </div>
      </div>
    </ng-template>
    <tmo-legal-text
      id="legal-text"
      [legalTitle]=""
      [legalContent]="contentData?.legalText"
    ></tmo-legal-text>
  </ng-container>
  <tmo-spinner [setDelay]="!isShowSpinner"></tmo-spinner>
</section>
<tmo-static-modal
  [modal]="fraudModal"
  (onClose)="handleModalButtonClickEvent($event)"
  (onSelect)="handleModalButtonClickEvent($event)"
></tmo-static-modal>
<tmo-dynamic-modal [modal]="migrationWelcomeModal">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closeMigrationModal()"
        id="cta-default-220"
        ><i class="fa fa-times"></i
      ></a>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <h3>{{ contentData?.migrationHeader }}</h3>
      </div>
    </div>
  </ng-container>
  <div class="row">
    <div class="col-12 text-center rpx-migration-padding">
      <p class="rpx-migration-body">{{ contentData?.migrationMessage }}</p>
    </div>
  </div>
  <ng-container footer>
    <div class="col-12 buttons-container button-spacing">
      <div class="button-box">
        <button class="btn btn-primary" (click)="closeMigrationModal()" id="btn-default-292">
          {{ contentData?.checkItOut }}
        </button>
      </div>
    </div>
  </ng-container>
</tmo-dynamic-modal>
